module.exports = __webpack_public_path__ + "img/area_10.fd33e483.png";